exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#page-wat-is .page__block{position:relative;padding:0 20%;display:flex;margin-bottom:50px}#page-wat-is .page__block-item{position:relative;opacity:1}.page-wat-is__text{transform:scale(0);transition:transform .7s}.page-wat-is__text.page-wat-is__text--active{transform:scale(1)}.page-wat-is__teacher{width:20%;height:100px;left:-53.33333vw;background-image:url(" + require("../../assets/images/docent-man-150.png") + ");transition:left .7s}.page__block--active .page-wat-is__teacher{left:0}.page-wat-is__quote{width:80%;padding-left:20px;left:113.33333vw;text-align:left;transition:left .7s .5s}.page__block--active .page-wat-is__quote{left:0}.page-wat-is__arrow-bullet{text-align:right}.page-wat-is__arrow-bullet span{margin-right:1em}.page-wat-is__list-item{text-align:left;font-size:1.1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6321fef7","scoped":false,"hasInlineConfig":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/page-wat-is-1.vue
// module id = 63
// module chunks = 0